<template>
  <div>
    <BaseAvatar
      :tint="materialResourceType?.color"
      :blink-icon="materialResourceType?.icon ?? 'exclamation-circle'"
      :border-color="borderColorComputed"
      :label="material_resource.name?.[$i18n.locale]"
      :size="size"
      :initials="material_resource.initials"
      hide-status
      blink-icon-enabled
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'

export default {
  name: 'MaterialResourceAvatar',
  components: { BaseAvatar },
  props: {
    materialResourceId: {
      type: String,
      required: true
    },
    ringColor: {
      type: String,
      required: false,
      default: null
    },
    disponibility: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  data() {
    return {
      hideStatus: true
    }
  },
  computed: {
    ...mapGetters({
      get_material_resource: 'metadata/getMaterialResourceMetadata',
      material_resources_types: 'metadata/getMetadataMaterialResourcesTypes'
    }),
    material_resource() {
      return this.get_material_resource(this.materialResourceId)
    },
    borderColorComputed() {
      if (this.disponibility) {
        switch (this.disponibility) {
          case 'pending':
            return 'border-yellow-400'
          case 'confirmed':
            return 'border-green-500'
          case 'refused':
            return 'border-red-500'
        }
      }
      return ''
    },
    materialResourceType() {
      return this.material_resources_types.find(
        (material_resources_type) =>
          material_resources_type.id === this.material_resource.type
      )
    }
  }
}
</script>
